import React from 'react';
import styled from '@emotion/styled';
import { TableCell } from '@mui/material';

export { default as TableContainer } from '@mui/material/TableContainer';
export { default as TableBody } from '@mui/material/TableBody';
export { default as TableCell } from '@mui/material/TableCell';
export { default as TableHead } from '@mui/material/TableHead';
export { default as TableRow } from '@mui/material/TableRow';

export { default } from '@mui/material/Table';

export const TableCellWithMonoSpaceFonts = styled(TableCell)`
  font-family: 'ui-monospace', 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas';
`;

interface SocialMediaValueCellProperties {
  value: number;
  alignRight?: boolean;
}

export const SocialMediaValueCell = ({
  value,
  alignRight,
}: SocialMediaValueCellProperties) => (
  <TableCellWithMonoSpaceFonts align={alignRight ? 'right' : 'left'}>
    {new Intl.NumberFormat('en-US').format(value)}
  </TableCellWithMonoSpaceFonts>
);
